export const baseUrl = __movietool.env.API_BASE_URL;
